import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Notistack from 'ui-component/third-party/Notistack';
import ResponseDialog from 'ui-component/extended/ResponseDialog';

import ThemeCustomization from 'themes';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';

// tab provider
import { TabProvider } from 'contexts/TabContext';

// dialog provider
import { DialogProvider } from 'contexts/DialogContext';
// organization provider
import { OrganizationProvider } from 'contexts/OrganizationContext';
// token refresh monitor
import TokenRefreshMonitor from 'components/TokenRefreshMonitor';
import RumClickTracker from 'rum/RumClickTracker';
import RumNavigationSync from 'rum/RumNavigationSync';

// ==============================|| APP ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <Locales>
        <NavigationScroll>
          <AuthProvider>
            <OrganizationProvider>
              <TabProvider>
                <DialogProvider>
                  <Notistack>
                    <TokenRefreshMonitor />
                    <RumNavigationSync />
                    <RumClickTracker />
                    <RouterProvider router={router} />
                    <Snackbar />
                    <ResponseDialog />
                  </Notistack>
                </DialogProvider>
              </TabProvider>
            </OrganizationProvider>
          </AuthProvider>
        </NavigationScroll>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>
  );
}
